import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import AppCard from './AppCard';

/**
 * Chat renderer for shared native report views (attachment type
 * 'native_report_share'). The shared URL carries the complete report state —
 * filters, drill-down expansion, even scroll position — so opening it
 * restores the exact view the sender was looking at.
 */
export default function NativeReportShareMessage({ message }) {
  const navigate = useNavigate();
  const attachment = (message.attachments || []).find((att) => att.type === 'native_report_share');
  if (!attachment || !attachment.url) return null;

  const { url, reportCategory, reportTitle, subtitle } = attachment;
  const senderName = String(message.user?.name || message.user?.id || 'the sender').split(' ')[0];

  const openView = () => {
    try {
      const parsed = new URL(url, window.location.origin);
      // same-app link: navigate relative so it works on any host/env
      navigate(`${parsed.pathname}${parsed.search}${parsed.hash}`);
      window.dispatchEvent(new CustomEvent('lodgeic:chat:navigated'));
    } catch (e) {
      window.location.href = url;
    }
  };

  return (
    <AppCard
      title={`${reportCategory ? `${reportCategory} · ` : ''}${reportTitle || 'Report'}`}
      subtitle={subtitle}
      footNote={`Opens ${senderName}’s exact view — filters and drill-downs included`}
      action={(
        <>
          Open view <ArrowRight size={14} aria-hidden="true" />
        </>
      )}
      onOpen={openView}
    />
  );
}
